export const RegisterEndPoints = {
  getRegisteredClients: {
    url: () => `/rest/v1/getRegisteredClients`,
    method: `GET`,
  },

  registerNewClient: {
    url: () => `/rest/v1/registerNewClient`,
    method: `POST`,
  },

  updateRegisteredClient: {
    url: () => `/rest/v1/updateRegisteredClient`,
    method: `PUT`,
  },

  deleteRegisteredClient: {
    url: () => `/rest/v1/deleteRegisteredClient`,
    method: `DELETE`,
  },

  getClientSubscriptions: {
    url: () => `/rest/v1/getClientSubscriptions`,
    method: `GET`,
  },

  updateClientSubscriptions: {
    url: () => `/rest/v1/updateClientSubscriptions`,
    method: `PUT`,
  },

  registerClientSubscriptions: {
    url: () => `/rest/v1/registerClientSubscriptions`,
    method: `POST`,
  },
  clearProcurementLogForProject: {
    url: (companyID, projectID) =>
      `/rest/v1/clearProcurementLogForProject/${companyID}/${projectID}`,
    method: `POST`,
  },
};
